if (document.getElementsByClassName('elite-features').length > 0) {
  await import('./elite')
}

if (document.getElementById('js-paypal-button')) {
  await import('./braintree')
}

export {}
